import Home             from "./pages/home"
import Noticia          from './pages/noticia'
import Acao             from './pages/acao'


const routes = [
    {
        name: 'home',
        path: '/',
        component: Home
    },
    {
        name: 'noticia',
        path: '/noticia/:slug',
        component: Noticia
    },
    {
        name: 'acao',
        path: '/acao/:slug',
        component: Acao
    },

  ]

  export default routes